import { API, retryRequest } from 'src/services'
import { freezeItems } from './freezeItems'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ commit }, payload) {
      const { fullReload } = payload || {}

      if (fullReload) {
        commit('resetItems')
      }

      commit('loading', true)
      const result = await retryRequest(API.regrasDeAprovacao.get)
      commit('saveItems', result.body)
    }
  }
}
